import React from "react";
import { Space, Tag, Typography } from "antd";
import { useSelector } from "react-redux";
import { draftBailiffDetailSelector } from "store/bailiff/draft/bailiff/draft_bailiff.selector";
import { useDraftDialogRefine } from "hook/draft/dialog/useDraftDialogRefine";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DetailHeader = () => {
  // -------------------------- VAR -----------------------------
  const data = useDraftDialogRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(draftBailiffDetailSelector);
  const name = detail?.name;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Space style={{ display: "flex", alignItems: "center" }}>
      <Typography.Title level={3} style={{ margin: 0 }}>
        {name}
      </Typography.Title>
      <Tag style={{ borderRadius: 30 }}>{data?.length} Dialogs</Tag>
    </Space>
  );
};
export default DetailHeader;
